'use client'
import React, { ReactNode } from 'react'
import Icon, { Icons } from '@crystal-eyes/components/elements/Icon/Icon'
import styles from './SectionCard.module.scss'
import usePrint from '../hooks/usePrint'
import useOrgLayoutSettings from '@crystal-eyes/hooks/useOrgLayoutSettings'
import { ErrorBoundary } from 'react-error-boundary'

interface Identity {
  id: string
}

type Props = {
  identity?: Identity
  icon?: Icons
  cardId: string
  title: string
  subtitle?: string
  sidebarTitle?: string
  showPrint?: boolean
  children: ReactNode
  className?: string
  style?: React.CSSProperties
}

export default function SectionCard({
  icon,
  cardId,
  title,
  subtitle,
  sidebarTitle,
  children,
  showPrint,
  className = '',
  style,
}: Props) {
  const {
    data: printSettings,
    modalState: { setShow: setShowModal },
  } = usePrint({ cardId })
  const { data: orgLayoutSettings } = useOrgLayoutSettings()

  if (orgLayoutSettings && orgLayoutSettings?.[cardId] === false) return null

  return (
    <div
      className={`${styles.sectionCard} ${
        showPrint && printSettings?.print ? 'yes-print' : 'no-print'
      } ${className}`}
      style={style}
    >
      <div className="section-card-heading CE Parented disc-color disc-background-light">
        <Icon
          icon={icon}
          className={`${styles.icon} ${
            cardId === 'my_personality' ? styles.myPersonality : ''
          }`}
        />

        <div className="title-subtitle">
          <h2
            id={cardId}
            data-card-id={cardId}
            data-sidebar-title={sidebarTitle}
            data-no-print={!showPrint}
            className="CE Parented disc-color"
          >
            {title}
          </h2>

          {subtitle && <span className="subtitle">{subtitle}</span>}
        </div>

        {showPrint && (
          <a
            className="print-link"
            href="#"
            onClick={(evt: React.MouseEvent) => {
              evt.preventDefault()
              setShowModal(true)
            }}
          >
            <Icon icon={Icons.Print} className={styles.icon} />
            Print
          </a>
        )}
      </div>

      <div className="section-card-content">
        <ErrorBoundary
          fallbackRender={() => (
            <p className="runtime-error-message">Something went wrong!</p>
          )}
        >
          {children}
        </ErrorBoundary>
      </div>
    </div>
  )
}
